import { humanizeType } from '@/spaces/chat/panels/panelLabel';

interface GenericReviewProps {
	content: Record<string, unknown>;
	artifactType?: string;
	allowJsonDump?: boolean;
}

export const GenericReview = ({
	content,
	artifactType,
	allowJsonDump = false,
}: GenericReviewProps) => {
	if (!allowJsonDump) {
		const label = artifactType ? humanizeType(artifactType) : 'This item';
		return (
			<p className="text-sm text-(--text-muted)">
				{label} · cannot preview yet
			</p>
		);
	}

	return (
		<pre
			style={{
				fontSize: '0.75rem',
				color: 'var(--text-secondary)',
				lineHeight: 1.5,
				background: '#f9fafb',
				padding: '0.75rem',
				borderRadius: '8px',
				overflow: 'auto',
				maxHeight: '12rem',
				whiteSpace: 'pre-wrap',
				wordBreak: 'break-word',
			}}
		>
			{JSON.stringify(content, null, 2)}
		</pre>
	);
};
